import { useState } from 'react'
import {
  Card,
  Title1,
  Body1,
  Input,
  Button,
  makeStyles,
  tokens,
  MessageBar,
  MessageBarBody,
} from '@fluentui/react-components'
import { ShieldLock24Regular } from '@fluentui/react-icons'
import { useAuthStore } from '../stores/authStore'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  card: {
    width: '100%',
    maxWidth: '400px',
    padding: tokens.spacingVerticalXXL,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: tokens.spacingVerticalM,
    marginBottom: tokens.spacingVerticalXL,
  },
  icon: {
    fontSize: '48px',
    color: tokens.colorBrandForeground1,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  pinInput: {
    '& input': {
      textAlign: 'center',
      fontSize: tokens.fontSizeBase500,
      letterSpacing: '0.5em',
    },
  },
  error: {
    marginTop: tokens.spacingVerticalS,
  },
})

export function PinLogin() {
  const styles = useStyles()
  const [pin, setPin] = useState('')
  const [error, setError] = useState(false)
  const login = useAuthStore((s) => s.login)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setError(false)
    
    if (!login(pin)) {
      setError(true)
      setPin('')
    }
  }

  const handlePinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6)
    setPin(value)
    setError(false)
  }

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <div className={styles.header}>
          <ShieldLock24Regular className={styles.icon} />
          <Title1>The Librarian</Title1>
          <Body1>Video Intelligence Portal</Body1>
        </div>
        
        <form onSubmit={handleSubmit} className={styles.form}>
          <Input
            className={styles.pinInput}
            type="password"
            placeholder="Enter PIN"
            value={pin}
            onChange={handlePinChange}
            autoFocus
            size="large"
          />
          
          <Button 
            type="submit" 
            appearance="primary" 
            size="large"
            disabled={pin.length !== 6}
          >
            Access Portal
          </Button>
          
          {error && (
            <MessageBar intent="error" className={styles.error}>
              <MessageBarBody>Invalid PIN. Please try again.</MessageBarBody>
            </MessageBar>
          )}
        </form>
      </Card>
    </div>
  )
}
